import { GTBusinessPartnerTaxPersonType, GTBusinessPartnerType, GTBusinessPartnerVertical } from 'gql/types.generated'

export enum EPartnerStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
export interface IBusinessPartnersFiltersForm {
  name: string
  email: string
  rfc: string
  taxPersonType: GTBusinessPartnerTaxPersonType | ''
  states: {
    code: string
    name: string
  }[]
  kamUser: {
    id: string
    firstName?: string
    lastName?: string
  }
  status: EPartnerStatus | ''
}

export enum NewPartnerStep {
  DATA = 1,
  GENERAL_INFORMATION = 2,
  DOCS = 3
}

export enum EPartnerType {
  HOST = 'HOST',
  FLEET = 'FLEET'
}
export interface IPartnerContact {
  id?: string
  name: string
  phone: string
  secondaryPhone?: string
  email: string
  secondaryEmail?: string
}
export interface INewPartnerData {
  name: string
  city?: {
    id?: string
    name?: string
    stateCode?: string
  }
  state?: {
    code?: string
    name?: string
  }
  operationalStates: {
    code: string
    name: string
  }[]
  type: GTBusinessPartnerType | ''
  verticals: GTBusinessPartnerVertical[]
}

export interface ITaxComplianceValues {
  taxPersonType: GTBusinessPartnerTaxPersonType | ''
  companyName?: string
  businessName?: string
  taxId: string
  curp?: string
  usePartnerName: boolean
  taxIdDocument?: {
    name?: string
    file?: File | ''
    path?: string
    id?: string
  }
  curpDocument: {
    name?: string
    file?: File | ''
    path?: string
    id?: string
  }
  taxRegime?: string
  proofOfTaxSituation?: string
  repseId?: string
  repseLink?: string
}

export interface INewPartnerStep1 extends INewPartnerData, ITaxComplianceValues {}
export interface INewPartnerStep2 {
  contacts: IPartnerContact[]
  bankData: {
    bankName: string
    clabeNumber: string
    email: string
    bankCoverLink?: string
    paymentType?: string
  }
}

export interface IPartnerDocumentsValues {
  id?: string
  category: string
  file: File | string
  filename?: string
}

export interface IPartnerUrbvanContact {
  id?: string
  firstName?: string
  lastName?: string
  username?: string
}

export interface INewPartnerStep3 {
  documents: IPartnerDocumentsValues[]
  kam: IPartnerUrbvanContact
}
export type INewPartnerValues = INewPartnerStep1

export interface IDeactivatePartnerForm {
  reason: string
  comments?: string
}
